export enum CreateReportModalTypes {
  request = 'Request',
  uploadFolder = 'UploadFolder'
}